import { useContext, useMemo } from 'react';
import { IAMRole } from 'libs.react';
import { AuthContext } from '../../contexts';
export const useUserRoles = () => {
    const { roleGroups, isInternalUser } = useContext(AuthContext);
    return useMemo(() => {
        const isDataAdmin = roleGroups.includes(IAMRole.DATA_TRANSFER_ADMIN);
        const isDataManager = roleGroups.includes(IAMRole.DATA_MANAGER);
        const isDataReviewer = roleGroups.includes(IAMRole.DATA_REVIEWER);
        return {
            isAIAdmin: roleGroups.includes(IAMRole.AI_ADMIN),
            isAIAuditor: roleGroups.includes(IAMRole.AI_AUDITOR),
            isAIBuilder: roleGroups.includes(IAMRole.AI_BUILDER),
            isAIUser: roleGroups.includes(IAMRole.AI_USER),
            isAdmin: roleGroups.includes(IAMRole.ADMIN),
            isBuilder: roleGroups.includes(IAMRole.BUILDER),
            isDataAdmin,
            isDataManager,
            isDataReviewer,
            isDataUser: isDataAdmin || isDataManager || isDataReviewer,
            isLibrarian: roleGroups.includes(IAMRole.LIBRARIAN),
            isSiteUser: roleGroups.includes(IAMRole.SITE_USER),
            isUserAndSiteManager: roleGroups.includes(IAMRole.USER_AND_SITE_MANAGER),
            isInternalUser,
        };
    }, [roleGroups]);
};
